import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useBidderCampaignTableOfContents = () => {
	const [isTableOfContents, setIsTableOfContents] = useState<boolean>(false);
	const location = useLocation();

	useEffect(() => {
		return () => setIsTableOfContents(false);
	}, [location]);

	return {
		isTableOfContents,
		tableOfContents: [
			{ id: 'basicInfo', element: 'Basic Info' },
			{ id: 'initialBids', element: 'Initial Bids' },
			{ id: 'bidderTargetings', element: 'Targetings' },
			{ id: 'bidderBlackWhiteLists', element: 'Black/White Lists' },
			{ id: 'bidderDomainLimits', element: 'Bidder Domain Limits' },
		],
		setIsTableOfContents,
	};
};
